import { render } from "./HealthPermit.vue?vue&type=template&id=4b54c7be&scoped=true"
import script from "./HealthPermit.vue?vue&type=script&lang=js"
export * from "./HealthPermit.vue?vue&type=script&lang=js"

import "./HealthPermit.vue?vue&type=style&index=0&id=4b54c7be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b54c7be"]])

export default __exports__